import { useEffect, useState } from "react";
import { Plus, Trash2, Megaphone } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function AdminAnnouncements() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", body: "", active: true });

  const load = async () => { const { data } = await api.get("/admin/announcements"); setItems(data); };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    const { data } = await api.post("/admin/announcements", form);
    setItems([data, ...items]); setForm({ title: "", body: "", active: true });
    toast.success("Posted");
  };
  const remove = async (id) => { await api.delete(`/admin/announcements/${id}`); setItems(items.filter((i) => i.id !== id)); };

  return (
    <div className="px-5 lg:px-10 py-8 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-brand-navy">Announcements</h1>
      <form onSubmit={add} className="mt-6 bg-white rounded-2xl border border-brand-borderc p-5 space-y-3">
        <input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="Title" className="w-full px-3 py-2.5 rounded-xl border border-brand-borderc text-sm" />
        <textarea required rows={3} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} placeholder="Body" className="w-full px-3 py-2.5 rounded-xl border border-brand-borderc text-sm" />
        <button className="btn-primary-gradient rounded-full px-5 py-2.5 text-sm font-semibold inline-flex items-center gap-1"><Plus className="w-4 h-4" />Post</button>
      </form>
      <div className="mt-5 space-y-3">
        {items.length === 0 ? (
          <div className="text-center py-12 text-brand-muted bg-white rounded-2xl border border-brand-borderc"><Megaphone className="w-10 h-10 mx-auto text-brand-purple" /><div className="mt-2">No announcements</div></div>
        ) : items.map((a) => (
          <div key={a.id} className="bg-white rounded-2xl border border-brand-borderc p-5">
            <div className="flex justify-between">
              <h3 className="font-semibold text-brand-navy">{a.title}</h3>
              <button onClick={() => remove(a.id)} className="p-1.5 text-red-500 hover:bg-red-50 rounded-lg"><Trash2 className="w-4 h-4" /></button>
            </div>
            <p className="text-sm text-brand-text mt-1">{a.body}</p>
            <div className="text-xs text-brand-muted mt-2">{new Date(a.created_at).toLocaleString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
